import React, { useEffect, useState } from "react";
import {
  listPosNotesApiCall,
  deleteNoteApiCall,
  updatePosNoteApiCall,
} from "../API/viewOrderSection";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import "../../../../../css/Sales/ListNotes.css";

function ListNotes({ setInput,input }) {
  const userLoginMeta = localStorage.getItem("login_meta");
  const userBranchId = JSON.parse(userLoginMeta)?.branchPk;
  const listNotes = useSelector(
    (state) => state.viewOrdersBillingSlice.posNotesList
  );

  const viewNotes = () => {
    listPosNotesApiCall({ branchId: userBranchId });
  };
  const selectNote = (value) => () => {
    setInput(value);
  };

  const handleDelete=(note)=>(e)=>{
    e.stopPropagation(); // Prevent the note's onClick event from firing
    deleteNoteApiCall({ noteId: note._id }, viewNotes);
    if (input === note.notes) {
      setInput(''); // Clear the input field if the deleted note is currently selected
    }
  }

  useEffect(() => {
    viewNotes();
  }, [userBranchId]);

   
  

  // Edit state
  const [editingId, setEditingId] = useState(null);
  const [editText, setEditText] = useState("");

  const startEdit = (note) => (e) => {
    e.stopPropagation();
    setEditingId(note._id);
    setEditText(note.notes);
  };

  const handleDoubleClick = (note) => (e) => {
    e.stopPropagation();
    setEditingId(note._id);
    setEditText(note.notes);
  };

  const saveEdit = (note) => async (e) => {
    e.stopPropagation();
    await updatePosNoteApiCall({ noteId: note._id, notes: editText }, () => {
      viewNotes();
      setEditingId(null);
      setEditText("");
    });
  };

  const cancelEdit = (e) => {
    e.stopPropagation();
    setEditingId(null);
    setEditText("");
  };

  return (
    <div className="list-notes-ctr">
      {listNotes?.map((note) => (
        <div key={note._id} onClick={selectNote(note.notes)} onDoubleClick={handleDoubleClick(note)} className="items">
          {editingId === note._id ? (
            <>
              <input
                value={editText}
                onChange={(e) => setEditText(e.target.value)}
                style={{ flex: 1, marginRight: 8 }}
              />
              <button onClick={saveEdit(note)} className="btn btn-primary" style={{marginRight:6}}>Save</button>
              <button onClick={cancelEdit} className="btn btn-secondary">Cancel</button>
            </>
          ) : (
            <>
              <span style={{whiteSpace:"pre-line", flex: 1}}>{note.notes}</span>
              <CloseIcon
                className="cross-icon"
                onClick={handleDelete(note)}
              />
            </>
          )}
        </div>
      ))}
    </div>
  );
}

export default ListNotes;
